import CryptoJS from 'crypto-js';

/** Backend: AES-256-CBC + PKCS7, zero IV, base64 key from `PayloadEncryptionKey`. */
const DEFAULT_PAYLOAD_KEY_B64 = 'CgQNC90vu6NJYBhEqjprMdpGDBJ68SF5xQKMYMkDomY=';
const ZERO_IV = CryptoJS.lib.WordArray.create([0, 0, 0, 0], 16);

function parseBase64WordArray(value) {
  return CryptoJS.enc.Base64.parse(String(value).trim());
}

function getKey() {
  const env = process.env.REACT_APP_PAYLOAD_ENCRYPTION_KEY || process.env.REACT_APP_AES_KEY;
  const keyB64 = env && String(env).trim() ? String(env).trim() : DEFAULT_PAYLOAD_KEY_B64;
  return parseBase64WordArray(keyB64);
}

function getIv() {
  const env = process.env.REACT_APP_PAYLOAD_ENCRYPTION_IV || process.env.REACT_APP_AES_IV;
  if (env && String(env).trim()) {
    const trimmed = String(env).trim();
    if (/^[A-Za-z0-9+/]+=*$/.test(trimmed) && trimmed.length >= 22) {
      return parseBase64WordArray(trimmed);
    }
    return CryptoJS.enc.Utf8.parse(trimmed.slice(0, 16));
  }
  return ZERO_IV;
}

const AES_OPTIONS = {
  get iv() {
    return getIv();
  },
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7,
};

/**
 * AES-256-CBC encrypt. Returns a base64 ciphertext string.
 */
export function encrypt(plainText) {
  if (plainText == null) return '';
  const text = typeof plainText === 'string' ? plainText : JSON.stringify(plainText);
  return CryptoJS.AES.encrypt(text, getKey(), AES_OPTIONS).toString();
}

/**
 * AES-256-CBC decrypt. Accepts base64 ciphertext from encrypt().
 */
export function decrypt(cipherText) {
  if (cipherText == null || cipherText === '') return null;
  try {
    const bytes = CryptoJS.AES.decrypt(String(cipherText), getKey(), AES_OPTIONS);
    const plain = bytes.toString(CryptoJS.enc.Utf8);
    return plain || null;
  } catch {
    return null;
  }
}
